type DevicesType = {
  fill?: string;
  className?: string;
};
const Devices = ({ fill = '#393939', className }: DevicesType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={className}
      fill="none"
    >
      <path
        fill={fill}
        d="M7.806 16.921a.708.708 0 1 0 0 1.417.708.708 0 0 0 0-1.417ZM5.256 16.921h1.417v1.417H5.256V16.92ZM6.673 19.47a.708.708 0 1 1-1.417.001.708.708 0 0 1 1.417 0ZM7.098 20.18v-1.417h1.417v1.416H7.098ZM24.438 21.803a.371.371 0 1 1-.742 0 .371.371 0 0 1 .742 0Z"
      />
      <path
        fill={fill}
        fillRule="evenodd"
        d="M3.215 23.826H13.94a.309.309 0 0 1-.174-.201c.054.168.184.231.335.231h1.082c.152 0 .28-.058.336-.231a.31.31 0 0 1-.171.201h13.436A1.22 1.22 0 0 0 30 22.617c0-.67-.55-1.218-1.215-1.218h-.442v-7.45c0-.861-.582-1.419-1.476-1.419h-.085v-2.264c0-1.482-.816-2.266-2.297-2.266H7.515c-1.424 0-2.297.784-2.297 2.266v3.114h-.165c-.812 0-1.354.518-1.354 1.293V21.4h-.484C2.55 21.4 2 21.947 2 22.617c0 .661.55 1.21 1.215 1.21ZM24.894 12.53v-1.763c0-.605-.304-.888-.893-.888H8c-.598 0-.893.283-.893.888v2.613h1.635c.799 0 1.331.518 1.331 1.293V21.4h2.404v-.02c0-.774.403-1.455 1.008-1.84h-.009a.495.495 0 0 0 .2-.277l.092-.27c.054-.169.184-.232.335-.232h1.082c.152 0 .282.063.336.231l.093.271c.04.126.1.209.199.276H15.8c.499.319.86.837.972 1.443h.003v-.001c.138 0 .23.098.23.244v.175h2.832v-7.45c0-.861.583-1.419 1.476-1.419h3.58ZM13.66 23.321l.005.012-.002-.005a.1.1 0 0 1-.003-.007Zm-.678-1.942c0 .921.744 1.67 1.66 1.67.915 0 1.66-.75 1.66-1.67 0-.92-.745-1.67-1.66-1.67-.915 0-1.66.75-1.66 1.67Zm-8.35.731c0 .355.21.556.579.556h3.347c.37 0 .58-.2.58-.556v-7.213c0-.355-.21-.56-.58-.56H5.212c-.369 0-.579.2-.579.556v7.217Zm16.188.107v-8.112c0-.382.227-.597.631-.597h5.277c.405 0 .632.216.632.597v8.112c0 .381-.227.601-.632.601h-5.276c-.405 0-.632-.22-.632-.601Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default Devices;
